module.exports = __webpack_public_path__ + "static/images/styles/images/icons/settings.3fb8e73b.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/icons/settings.png
// module id = 3642
// module chunks = 11